export default "__VITE_ASSET__DocBt$58__"